(function () {
  const productContent = document.getElementsByClassName(
    'product__content'
  )[0];
  const sprStarRating =
    document.getElementsByClassName('spr-starrating')[0];

  if (!productContent && !sprStarRating) {
    if (productContent.classList.contains('text-center')) {
      sprStarRating.style.justifyContent = 'center';
    } else if (productContent.classList.contains('text-right')) {
      sprStarRating.style.justifyContent = 'flex-end';
    } else if (productContent.classList.contains('text-left')) {
      sprStarRating.style.justifyContent = 'flex-start';
    }
  }
})();


document.addEventListener("DOMContentLoaded", () => {
  function initSwiper() {
    if (window.innerWidth < 750) {
      const sliderContentGrid = document.querySelector(".swiper__content-grid");
      if (sliderContentGrid) {
        const swiperContentGrid = new Swiper(sliderContentGrid, {
          slidesPerView: 1,
          spaceBetween: 16,
          autoplay: {
            delay: 3000
          },
          loop: true
        });
      }
    }
  }
  initSwiper();
  window.addEventListener("resize", initSwiper);
});
